export default "__VITE_ASSET__bDYkIrQl__"